module.exports = __webpack_public_path__ + "static/media/shield.2afd7d6e.png";